import React from 'react'
import s from './ImageWithFallback.less'
import classnames from 'classnames'

const ImageWithFallback = ({ image, fallbackImage, height, width, alt, lazyLoading = true, className }) => (
  <picture className={s.root}>
    {image && (
      <source className={className} srcSet={typeof image === 'string' ? image : image?.src} type="image/webp" />
    )}
    <img
      className={classnames(s.image, className)}
      src={fallbackImage}
      width={width}
      height={height}
      alt={alt}
      loading={lazyLoading ? 'lazy' : 'eager'}
    />
  </picture>
)

export default ImageWithFallback
